import React, { useEffect, useState } from "react";
import _OrderRow from "./_OrderRow";
import { FaSearch } from "react-icons/fa";
import { useAppContext } from "../../../../../../Components/AppProvider";

function _Paid() {
  const [expandedId, setExpandedId] = useState(null);
  const [menuOpenId, setMenuOpenId] = useState(null);
  const [cancelledOrder, setCancelledOrder] = useState([]);
  const [updatePendingOrder, setUpdatePendingOrder] = useState(false);

  // ✅ search state
  const [searchTerm, setSearchTerm] = useState("");
  const { setCountListUpdate } = useAppContext();

  // ✅ keep track of selected orders
  const [selectedOrders, setSelectedOrders] = useState([]);

  useEffect(() => {
    let intervalId;

    async function fetchOrderContent() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/get-cancelled-order`,
          { credentials: "include" },
        );

        if (!res.ok) {
          console.error("HTTP error:", res.status);
          return;
        }

        const data = await res.json();
        if (Array.isArray(data.cancelledOrder)) {
          setCancelledOrder(data.cancelledOrder);
          //console.log("data.cancelledOrder :", data.cancelledOrder);
        } else {
          console.error("Invalid response:", data);
          setCancelledOrder([]);
        }
      } catch (err) {
        console.error("Failed to fetch pending orders", err);
        setCancelledOrder([]);
      }
    }

    fetchOrderContent(); // run immediately once

    // ⏱️ set interval
    intervalId = setInterval(fetchOrderContent, 10000);

    // 🧹 cleanup when component unmounts or dependency changes
    return () => clearInterval(intervalId);
  }, [updatePendingOrder]);

  // ✅ filter orders based on search term
  const filteredOrders = cancelledOrder.filter((order) => {
    const keyword = searchTerm.toLowerCase();

    const displayStatus =
      order.COI_Status === "Paid" ? "FP Paid" : order.COI_Status || "";

    return (
      order.PD_Name?.toLowerCase().includes(keyword) ||
      order.PO_Number?.toLowerCase().includes(keyword) ||
      `${order.CP_Firstname} ${order.CP_Lastname}`
        .toLowerCase()
        .includes(keyword) ||
      displayStatus.toLowerCase().includes(keyword)
    );
  });

  // ✅ handle toggle of one row
  const handleRowSelect = (id) => {
    setSelectedOrders((prev) =>
      prev.includes(id) ? prev.filter((oid) => oid !== id) : [...prev, id],
    );
  };

  // ✅ handle toggle all
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedOrders(filteredOrders.map((o) => o.COI_ID));
    } else {
      setSelectedOrders([]);
    }
  };

  // ✅ check if all are selected
  const allSelected =
    filteredOrders.length > 0 &&
    filteredOrders.every((o) => selectedOrders.includes(o.COI_ID));

  const HandleDelete = async (order) => {
    try {
      console.log("Attempting to delete order:", order);
      if (
        !window.confirm(
          `Are you sure you want to delete order #${order.COI_ID}? This action cannot be undone.`,
        )
      )
        return;
      //console.log("order: ", order);
      // 1️⃣ Update order status to "Ready to Ship"
      const updateRes = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/orders/delete-cancelled-order`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            COI_ID: order.COI_ID,
          }),
        },
      );

      if (!updateRes.ok) {
        throw new Error("Failed to update order status");
      }

      setUpdatePendingOrder((p) => !p); // refresh table
      setCountListUpdate((prev) => !prev);
      setSelectedOrders([]); // clear selection
      alert(`Order #${order.COI_ID} deleted successfully ✅`);
    } catch (error) {
      console.error("Error deleting order:", error);
      alert("Something went wrong while deleting the order.");
    }
  };
  const handleBulkDeleteCancelledOrder = async () => {
    try {
      console.log("Attempting to bulk delete orders:", selectedOrders);
      if (
        !window.confirm(
          `Are you sure you want to delete ${selectedOrders.length} cancelled orders? This action cannot be undone.`,
        )
      )
        return;
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/orders/delete-cancelled-order`,
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ COI_ID: selectedOrders }),
        },
      );

      if (!res.ok) throw new Error("Bulk update failed");

      const data = await res.json();
      alert(data.message);

      setUpdatePendingOrder((p) => !p); // refresh table
      setCountListUpdate((prev) => !prev);
      setSelectedOrders([]); // clear selection
    } catch (err) {
      console.error("Bulk update error:", err);
      alert("Failed to update orders");
    }
  };
  return (
    <main className="ad-order-panel-container">
      <div className="order-panel-header">
        <div className="order-panel-title-wrapper">
          <span>CANCELLED ORDERS</span>
        </div>
        <div className="order-panel-actions-wrapper">
          {/* ✅ Only show button when there are selected orders */}
          {selectedOrders.length > 0 && (
            <button
              onClick={() => {
                handleBulkDeleteCancelledOrder();
              }}
            >
              DELETE ({selectedOrders.length})
            </button>
          )}

          <div className="order-search-bar">
            <input
              type="text"
              placeholder="Keyword..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span>
              <FaSearch />
            </span>
          </div>
        </div>
      </div>

      <div className="order-panel-table-wrapper">
        <table>
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={handleSelectAll}
                />
              </th>
              <th></th>
              <th>PRODUCT NAME</th>
              <th>CUSTOMER NAME</th>
              <th>DATE CANCELLED</th>
              <th>CANCELLED BY</th>
              <th>REASON FOR CANCELLATION</th>
              <th>STATUS</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filteredOrders.length > 0 ? (
              filteredOrders.map((order) => (
                <_OrderRow
                  key={order.COI_ID}
                  order={order}
                  menuOpenId={menuOpenId}
                  setMenuOpenId={setMenuOpenId}
                  isSelected={selectedOrders.includes(order.COI_ID)}
                  setExpandedId={setExpandedId}
                  expandedId={expandedId}
                  onSelect={() => handleRowSelect(order.COI_ID)}
                  HandleDelete={HandleDelete}
                />
              ))
            ) : (
              <tr>
                <td
                  colSpan="10"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </main>
  );
}

export default _Paid;
